import { Injectable } from '@angular/core';
import {
  ActiveState,
  EntityState,
  EntityStore,
  StoreConfig,
} from '@datorama/akita';
import { Organization } from '@etrucking/iam/core';

export interface OrganizationsState
  extends EntityState<Organization, string>,
    ActiveState<string> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'iam.organizations' })
export class OrganizationsStore extends EntityStore<OrganizationsState> {
  constructor() {
    super();
  }
}
